import React, { useState, useEffect } from "react";
import { toastr } from "react-redux-toastr";

import Notifications from "./components/Notifications";

import * as notificationsAPI from "api/notifications";

const NotificationsPage: React.SFC = () => {
  const [notifications, setNotifications] = useState<any | undefined>(
    undefined
  );
  const getNotifications = () => {
    notificationsAPI.getSelectedNotifications().then((response: any) => {
      if (response.success) {
        setNotifications(response.data);
      } else {
        toastr.error("Ошибка получения выбранных уведомлений", response.error);
      }
    });
  }
  useEffect(() => {
    getNotifications();
  }, []);

  const handleChangeNotifications = (type_no: number, email: boolean, sms: boolean) => {
    notificationsAPI.updateNotifications({type_no, email, sms}).then((response: any) => {
      if (response.success) {
        getNotifications();
        toastr.success("Уведомление успешно изменено", '');
      } else {
        toastr.error("Ошибка измеения уведомления", response.error);
      }
    })
  }

  return (
    <React.Fragment>
      <div className="container bug_1200">
        <div className="row bug_1200_row">
          <div className="col-12 mb-3">
            <h2 className="title_n">Центр уведомлений</h2>
          </div>
          {notifications && notifications.map((item: any, index: number) => (
            <Notifications {...item} key={`${item.id} ${index}`} onHandleChange={handleChangeNotifications}/>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};

export default NotificationsPage;
